<template>
  <div>
    <b-modal
      id="amex-status-modal"
      ref="amex-status-info-modal-ref"
      hide-footer
      title="Bank Transfer Payment Status"
    >
      <div class="vtd-modal-content">
        <div class="vtd-modal-body">
          <div
            class="vtd-alert vtd-alert-global vtd-has-icon vtd-mb-5"
            role="alert"
            id="app_warning"
            v-if="payload.status === 'ERROR'"
          >
            <!-- This text is only to appear if the desclinks variable contains '' -->
            <div class="media-body">
              <i class="material-icons vtd-pr-3 vtd-align-middle text-danger"
                >&#xE002;</i
              >
              <span class="text-danger">
                <span
                  class="glyphicon glyphicon-exclamation-sign"
                  aria-hidden="true"
                ></span>
                Unfortunately your bank has not authorised the payment.
                <br /><br />
                Please <a @click="hideModal()">click here</a> to return to
                Viewtrail to pay via another method or contact your bank for
                details.
              </span>
            </div>
          </div>

          <div class="success" v-if="payload.status === 'AMEX_COMPLETE'">
            Thank you.<br /><br />
            Your payment for <span>{{ payload.amount }}</span> has been
            received. <br /><br />
            You will receive an email confirmation shortly.
          </div>

          <div
            class="warning"
            v-if="
              payload.status === 'AMEX_PENDING' ||
              payload.status === 'AMEX_IN_PROGRESS'
            "
          >
            Your payment is taking a little longer than expected to authorise.
            We will send you an email once confirmed.
            <br /><br />
            Thank you
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return { payload: {} };
  },

  methods: {
    async showModal(payload) {
      this.payload = payload;
      this.$refs["amex-status-info-modal-ref"].show();
    },
    hideModal() {
      this.$refs["amex-status-info-modal-ref"].hide();
    },
  },
};
</script>

<style>
</style>
